module.exports = __webpack_public_path__ + "static/media/italy.cc79b186.png";